import MuiSvgIcon from './MuiIcon';

const ChevronDown = (props) => {
  return (
    <MuiSvgIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7225 8.27958C18.0925 8.65235 18.0925 9.25674 17.7225 9.62951L12.6699 14.7204C12.2999 15.0932 11.7001 15.0932 11.3301 14.7204L6.27748 9.62951C5.90751 9.25674 5.90751 8.65235 6.27748 8.27958C6.64745 7.90681 7.24729 7.90681 7.61726 8.27958L12 12.6955L16.3827 8.27958C16.7527 7.90681 17.3526 7.90681 17.7225 8.27958Z"
      />
    </MuiSvgIcon>
  );
};

export default ChevronDown;
